<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'AccountExports'}" class="subtitle-1 routerLink font-weight-medium">Exportar</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>Facturas
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 pb-0 background">
          <v-row class="px-4">
            <v-col cols="12" sm="10" md="9">
              <span class="body-2 text--secondary font-weight-medium">Filtrar registros</span>
              <v-query-builder :flat="true" :query-map="rules" filter-text="Previsualizar" model="invoice" />
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">Previsualización</span>
            </v-col>
          </v-row>
          <v-divider />
          <invoice-list :show-pagination="false" />
          <v-divider />
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">{{count}} registros</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="createExport" :loading="$store.state.accounts.createLoader" color="primary">Exportar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import { invoiceFilters } from '../../../collections/queryBuilderFilters'

import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import InvoiceList from '@/components/invoice/InvoiceList'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VQueryBuilder,
    InvoiceList
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    isPreview: false,
    rules: invoiceFilters
  }),
  computed: mapState({
    count: state => state.invoices.invoicesCount,
    invoicesList: state => state.invoices.invoicesList
  }),
  methods: {
    getList () {
      this.$store.dispatch('invoices/LIST', {
        resource: 'invoices',
        query: Object.assign({}, this.$route.query, {
          page_size: 10
        })
      })
    },
    str2bytes (str) {
      var bytes = new Uint8Array(str.length)
      for (var i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i)
      }
      return bytes
    },
    createExport () {
      this.$store.dispatch('accounts/LIST', {
        resource: 'exports/invoices',
        query: this.$route.query,
        loader: true,
        responseType: 'arraybuffer'
      })
      .then(async (response) => {
        let blob = await new Blob([response.data], {type: "application/zip"})
        saveAs(blob, 'invoices.zip')
        this.$dialog.message.info('La exportación se realizó con éxito')
      })
      .catch(() => {
        this.$dialog.message.error('Ha ocurrido un error en la exportación')
      })
    }
  }
}
</script>